import { useCurrentPos } from "../../hooks/use-current-pos";
import { Link, useNavigate, useParams } from "react-router";
import { urlScanProduct, urlSelectProduct } from "../../urls";
import type { Product, ProductCategory } from "@repo/shared-types";
import { OptionsGrid } from "../../components/options-grid";
import { ProductButton } from "../../components/product-button";
import { useBarcodeScanner } from "../../hooks/use-barcode-scanner";
import { toast } from "sonner";
import { useSendEvent } from "../../hooks/use-send-event";
import { productsAtom } from "../../stores/pos";
import { useSetAtom } from "jotai";
import { Button } from "@repo/ui/components/button";
import { ArrowLeft } from "lucide-react";

function SelectProduct() {
  const navigate = useNavigate();
  const { club } = useCurrentPos();
  const sendEvent = useSendEvent();
  const { category } = useParams();
  const setProducts = useSetAtom(productsAtom);
  const addProduct = (product: Product) => {
    setProducts((prev) => [...prev, product]);
  };

  const categoryId = category as string;

  useBarcodeScanner({
    onScan: (barcode) => {
      const allProducts = club.productCategories.flatMap(
        (category) => category.products
      );
      const product = allProducts.find((product) => product.sku === barcode);
      if (product) {
        sendEvent("scan_product", {
          barcode,
          from: "select-product",
          error: false,
        });
        onSelect(product.id);
      } else {
        sendEvent("scan_product", {
          barcode,
          from: "select-product",
          error: true,
        });
        toast.error("Producto no encontrado");
      }
    },
  });

  const onSelect = (productId: string) => {
    const product = club.productCategories
      .flatMap((category) => category.products)
      .find((product) => product.id === productId);
    if (!product) {
      toast.error("Producto no encontrado");
      return;
    }
    addProduct(product);
    navigate(urlScanProduct(), { viewTransition: true });
  };

  const categoryProducts =
    club.productCategories
      .find((category: ProductCategory) => category.id === categoryId)
      ?.products.filter(
        (product: Product & { categoryId: string }) =>
          product.categoryId === categoryId && product.showOnPOS
      ) ?? [];

  return (
    <div className="w-full flex-1 overflow-y-auto overflow-x-hidden py-4 min-h-0">
      <Button
        className="absolute left-0"
        asChild
        size="2xl"
        variant="pos-outline"
      >
        <Link to={urlScanProduct()} viewTransition>
          <ArrowLeft className="size-4" />
          Volver
        </Link>
      </Button>
      <div className="min-h-full flex items-center justify-center">
        <OptionsGrid>
          {categoryProducts.map((product) => (
            <ProductButton
              key={product.id}
              product={product}
              onClick={() => {
                sendEvent("select_product", { productId: product.id });
                onSelect(product.id);
              }}
            />
          ))}
        </OptionsGrid>
      </div>
    </div>
  );
}

export const route = {
  path: urlSelectProduct(":category"),
  element: <SelectProduct />,
  handle: {
    backLink: -1,
    title: "Selecciona el producto",
  },
};
